import Navbar from 'componets/navbar';
import styles from './index.module.sass';

const LoginLayout = ({ children }) => {
  return (
    <div className={styles['login-layout']}>
      <Navbar theme="black" isLogin={false} />
      <div className={styles.content}>{children}</div>
    </div>
  );
};

export default LoginLayout;
